import React, { useState } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import "../styles/Z1.css";

// ⭐ Example 5 rows data – replace with your images, headings & text
import img1 from "../assets/images/item5/subitm1.jpg";
import img2 from "../assets/images/item5/subitm2.jpg";
import img3 from "../assets/images/item5/subitm3.jpg";
import img4 from "../assets/images/item5/subitm4.jpg";
import img5 from "../assets/images/item5/subitm5.jpg";

const rowsData = [
  {
    id: 1,
    title: "Pneumatic Cylinders",
    text: "High-quality pneumatic cylinders for smooth and efficient linear motion.",
    img: img1,
    gradient: "gradient1",
    stars: 4,
    description: `Pneumatic cylinders use compressed air to produce precise linear movement. They are ideal for automation, material handling, and industrial machinery. Built with durable materials to handle high-pressure operations.
`
  },
  {
    id: 2,
    title: "Pneumatic Solenoid Valves",
    text: "Reliable pneumatic solenoid valves for quick and accurate air-flow control.",
    img: img2,
    gradient: "gradient2",
    stars: 5,
    description: `Pneumatic solenoid valves control the direction of compressed air in automation systems. They enable fast and efficient operation of pneumatic actuators and cylinders. Designed for high-speed switching and long service life.
`
  },
  {
    id: 3,
    title: "All Type Of Seals",
    text: "Durable seals to prevent leaks and ensure airtight pneumatic operations.",
    img: img3,
    gradient: "gradient3",
    stars: 3,
    description: `These seals maintain air pressure and prevent leaks in pneumatic systems. Made from high-quality rubber or polymer materials for long-lasting performance. Available in different types such as O-rings, gaskets, and rod seals.
`
  },
  {
    id: 4,
    title: "Pneumatic Hose & Fittings",
    text: "Flexible pneumatic hoses and fittings for safe air transmission.",
    img: img4,
    gradient: "gradient4",
    stars: 4,
    description: `Pneumatic hoses and fittings ensure secure and efficient air flow in pneumatic systems. Made from strong, flexible materials to withstand high pressure. Available in various sizes and connection types to suit industrial needs.
`
  },
  {
    id: 5,
    title: "Pneumatic Jack & Air Bellow",
    text: "Heavy-duty pneumatic jacks and air bellows for lifting and vibration control.",
    img: img5,
    gradient: "gradient5",
    stars: 5,
    description: `Pneumatic jacks use compressed air to lift heavy loads effortlessly. Air bellows provide shock absorption and vibration damping in industrial applications. Designed for durability and high load-bearing capacity.`
  }
];

function Z5() {
  const [selectedRow, setSelectedRow] = useState(null);

  return (
    <>
      <Navbar />

      <section className="z1-section">
        {rowsData.map((row) => (
          <div
            key={row.id}
            className={`z1-row ${row.gradient}`}
            onClick={() => setSelectedRow(row)}
          >
            <div className="z1-img">
              <img src={row.img} alt={row.title} />
            </div>

            <div className="z1-content">
              <h2>{row.title}</h2>
              <p>{row.text}</p>
              <div className="stars">
                {"★".repeat(row.stars)}
                {"☆".repeat(5 - row.stars)}
              </div>
            </div>
          </div>
        ))}
      </section>

      {/* 🔹 Popup / Modal */}
      {selectedRow && (
        <div className="z1-modal-overlay" onClick={() => setSelectedRow(null)}>
          <div
            className="z1-modal"
            onClick={(e) => e.stopPropagation()} // prevent close on inner click
          >
            <h2>{selectedRow.title}</h2>

            <div className="modal-body">
              <div className="modal-img">
                <img src={selectedRow.img} alt={selectedRow.title} />
              </div>
              <div className="modal-text">
                <p>{selectedRow.description}</p>
              </div>
            </div>

            <button
              className="close-btn"
              onClick={() => setSelectedRow(null)}
            >
              Close
            </button>
          </div>
        </div>
      )}

      <Footer />
    </>
  );
}

export default Z5;